var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-list" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "el-tab-pane",
            { key: tab.id, attrs: { label: tab.label, name: tab.name } },
            [
              _c(
                "el-button",
                {
                  staticClass: "add-version-btn",
                  attrs: { type: "add", size: "14" },
                  on: {
                    click: function ($event) {
                      return _vm.handleAddOrEdit({}, "add")
                    },
                  },
                },
                [_vm._v("新增" + _vm._s(_vm.activeName) + "版本")]
              ),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeName === tab.name,
                          expression: "activeName === tab.name",
                        },
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        size: "medium",
                        "header-cell-style": { background: "#F5F6F7" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "版本号" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.versionCode || "-") +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.status(scope.row.status) || "-"
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "提示频率" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.frequency(scope.row.frequency) ||
                                          "-"
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "更新说明" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.description || "-") +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "操作",
                          width: "180px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status === 0 ||
                                  scope.row.status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "operate",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleAddOrEdit(
                                                scope.row,
                                                "edit"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "operate",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleTest(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("测试")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "operate",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleGoLive(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("上线")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 2
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "operate",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleOffline(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下线")]
                                      )
                                    : _vm._e(),
                                  scope.row.status === 0 ||
                                  scope.row.status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "operate",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 50],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }